import React from "react";
import { useTranslation } from "react-i18next";

interface BookingReferenceProps {
  bookingRef: string;
  className?: string;
}

const BookingReference: React.FC<BookingReferenceProps> = ({ bookingRef, className = "gcw:mb-0 gcw:text-ref" }) => {
  const { t } = useTranslation();

  if (!bookingRef?.trim()) {
    return null;
  }

  return (
    <p className={className}>
      {t("booking_reference_label", "Booking reference:")} <strong>{bookingRef}</strong>
    </p>
  );
};

export default BookingReference;
